export default __webpack_public_path__ + "static/media/quotation-thumbnail.889379f1.png";